module.exports = __webpack_public_path__ + "img/upload-img-id-emblem.svg";